import { Injectable, signal } from '@angular/core';

export interface AppNotification {
    severity: 'success' | 'info' | 'warn' | 'error';
    summary: string;
    detail?: string;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
    readonly pending = signal<AppNotification[]>([]);

    show(notification: AppNotification): void {
        this.pending.update(list => [...list, notification]);
    }

    drain(): AppNotification[] {
        const items = this.pending();
        this.pending.set([]);
        return items;
    }
}
